import { ExtendedAccount } from "@common/types/reports/types";
import { ChartOfAccountsEntityGroup } from "@common/schemas/domains/accounting/report.schema";
import { DraftAccount, DraftGroup } from "../draftState";

// codeText is kept as stored (no codeToText(code)): live-chart codes are free
// text.
export const mapWorkspaceAccountsToDraft = (
    accounts: ExtendedAccount[],
): DraftAccount[] =>
    accounts.map((account) => ({
        id: account.id,
        entityId: account.entityId,
        codeText: account.codeText,
        name: account.name,
        type: account.type,
        isDisabled: account.isDisabled,
        isManuallyCreated: account.isManuallyCreated,
        kickOriginalCode: account.kickOriginalCode,
        parentGroupId: account.parentGroupId,
        sortOrder: account.sortOrder,
    }));

export const mapWorkspaceGroupsToDraft = (
    groups: ChartOfAccountsEntityGroup[],
): DraftGroup[] =>
    groups.map((group) => ({
        id: group.id,
        entityId: group.entityId,
        name: group.name,
        type: group.type,
        parentGroupId: group.parentGroupId,
        sortOrder: group.sortOrder,
    }));

// Temp-id rows miss this map and so get all-null capability reasons.
export const buildWorkspaceAccountsById = (
    accounts: ExtendedAccount[],
): Map<string, ExtendedAccount> =>
    new Map(accounts.map((account) => [account.id, account]));
